import { StoreState } from "../models";

export const initialState: StoreState = {
  logbox: {
    snackbar: { text: "", severity: "info", isOpen: false },
    logs: [],
  },
  login: {
    isLoggedIn: false,
    isLoggingIn: false,
    loginFailure: "",
    user: null,
  },
  millSelector: {
    fetching: true,
    didInvalidate: false,
    mills: [],
    selectedMill: null,
    selectedLineId: null,
  },
  timeSelector: {
    startTime: "",
    endTime: "",
    localMillTime: "",
  },
  fuelComposition: {
    submitPending: false,
    data: [],
  },
  dampers: {
    fetching: true,
    didInvalidate: false,
    fetchTime: "",
    fetchLine: "",
    overrideAll: false,
    data: [],
  },
  startupBurnerOverride: {
    fetching: true,
    didInvalidate: false,
    fetchTime: "",
    fetchLine: "",
    overrideAll: false,
    data: {
      tags: [],
      total_cooling_air: {
        value: null,
        newPosition: null,
        override: false,
      },
    },
  },
};
